import { createApp } from 'vue';
import './iconify-local';

let app = createApp({})
let milestone_component = document.getElementById('v_component')
app.config.compilerOptions.isCustomElement = (tag) => tag === 'iconify-icon'
app.component('milestones-configuration', require('../js/vue-components/MilestonesConfiguration.vue').default);
const RegionLocations = require('../js/vue-components/RegionLocations.vue').default;
const AudienceBuilder = require('../js/vue-components/AudienceBuilder.vue').default;
const EmailComposer = require('../js/vue-components/EmailComposer.vue').default;
const SmsComposer = require('../js/vue-components/SmsComposer.vue').default;
const DmProfiles = require('../js/vue-components/DmProfiles.vue').default;

// if(milestone_component) {
//     window.onload = () => {
//         app.mount(milestone_component)
//     }
// }

// ✅ Mount immediately after DOM is ready (before images etc.)
if (milestone_component) {
    document.addEventListener('DOMContentLoaded', () => {
        app.mount(milestone_component);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const regionMounts = document.querySelectorAll('[data-region-targeting]')
    regionMounts.forEach((mountEl) => {
        const props = mountEl.dataset.props ? JSON.parse(mountEl.dataset.props) : {}
        const regionApp = createApp(RegionLocations, props)
        regionApp.config.compilerOptions.isCustomElement = (tag) => tag === 'iconify-icon'
        regionApp.mount(mountEl)
    })

    const audienceMounts = document.querySelectorAll('[data-audience-builder]')
    audienceMounts.forEach((mountEl) => {
        const props = mountEl.dataset.props ? JSON.parse(mountEl.dataset.props) : {}
        createApp(AudienceBuilder, props).mount(mountEl)
    })

    const composerMounts = document.querySelectorAll('[data-email-composer]')
    composerMounts.forEach((mountEl) => {
        const props = mountEl.dataset.props ? JSON.parse(mountEl.dataset.props) : {}
        createApp(EmailComposer, props).mount(mountEl)
    })

    document.querySelectorAll('[data-dm-profiles]').forEach((mountEl) => {
        const props = mountEl.dataset.props ? JSON.parse(mountEl.dataset.props) : {}
        createApp(DmProfiles, props).mount(mountEl)
    })

    const smsComposerMounts = document.querySelectorAll('[data-sms-composer]')
    smsComposerMounts.forEach((mountEl) => {
        const props = mountEl.dataset.props ? JSON.parse(mountEl.dataset.props) : {}
        createApp(SmsComposer, props).mount(mountEl)
    })
})
